import { ALL_LEADER_GROUPS_QUERY } from '@/modules/companies'
import { useQuery } from '@apollo/client'
import { useAdmin } from './useAdmin'

export function useLeaderGroups() {
  const isAdmin = useAdmin()
  const { data, loading: groupsLoading } = useQuery(ALL_LEADER_GROUPS_QUERY)

  const allGroups = data?.allLeaderGroups ?? []

  const { myLeaderGroups, defaultLeaderGroup, hasAccess } = {
    myLeaderGroups: allGroups,
    defaultLeaderGroup: allGroups[0] ?? null,
    hasAccess: isAdmin || allGroups.length > 0,
  }

  return { hasAccess, myLeaderGroups, defaultLeaderGroup, groupsLoading }
}
